import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = signed-in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        api.get("/auth/me")
            .then((res) => active && setUser(res.data))
            .catch(() => active && setUser(false))
            .finally(() => active && setLoading(false));
        return () => { active = false; };
    }, []);

    const value = useMemo(() => ({
        user,
        loading,
        async login(email, password) {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            return data.user;
        },
        async register(email, password, name, specialized_role, covenant_accepted = false) {
            const { data } = await api.post("/auth/register", { email, password, name, specialized_role, covenant_accepted });
            setUser(data.user);
            return data.user;
        },
        async logout() {
            try { await api.post("/auth/logout"); } catch (_) { /* noop */ }
            setUser(false);
        },
    }), [user, loading]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
